import _defineProperty from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _arrayLikeToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray";
import _toArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, Paper, Select, TextField, Typography } from "@mui/material";
import { ExpandMore, Visibility, VisibilityOff } from "../icons.js";
import ArrayForm from "./arrayForm.js";
import { styled } from "@mui/material/styles";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Root = styled("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    marginBottom: theme.spacing(2),
    // Default margin
    "&.Mui-expanded:last-child": {
      marginBottom: theme.spacing(4) // Margin when expanded
    }
  };
});
var BoltForm = function BoltForm(_ref2) {
  var isSuperUserOrStaff = _ref2.isSuperUserOrStaff,
    keyJson = _ref2.keyJson,
    type = _ref2.type;
  var _useState = useState({
      bolt: "",
      user: "",
      password: "",
      auth: {
        scheme: "basic",
        principal: "",
        credentials: "",
        realm: ""
      },
      neptune: type === "Neptune" ? {
        signedHeader: false,
        protocol: "bolt",
        hostname: "",
        port: 8182,
        path: "",
        region: "",
        service: ""
      } : undefined,
      driverConfig: {
        encrypted: "",
        trust: "",
        trustedCertificates: [],
        knownHosts: "",
        fetchSize: "",
        maxConnectionPoolSize: "",
        maxTransactionRetryTime: "",
        maxConnectionLifetime: "",
        connectionAcquisitionTimeout: "",
        connectionTimeout: "",
        disableLosslessIntegers: false,
        useBigInt: false,
        userAgent: ""
      },
      logging: {
        level: ""
      },
      driverVersion: "4.4",
      persistConnection: true,
      searchMaxTime: 20 * 1000,
      metadata: "",
      schema: {
        defaultTimeIndex: {
          nodeProperties: [],
          relationshipProperties: []
        },
        inferSchema: true,
        inferTimeout: 2,
        labelProperties: "",
        relationshipProperties: "",
        textIndexes: []
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    formFields = _useState2[0],
    setFormFields = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPassword = _useState4[0],
    setShowPassword = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    errorText = _useState6[0],
    setErrorText = _useState6[1];
  var handleTogglePasswordVisibility = function handleTogglePasswordVisibility() {
    setShowPassword(!showPassword);
  };
  useEffect(function () {
    if (keyJson !== undefined) {
      setFormFields(function (formFields) {
        return _objectSpread(_objectSpread({}, formFields), keyJson);
      });
    }
  }, [keyJson]);
  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
  };
  var updateNestedField = function updateNestedField() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var keys = arguments.length > 1 ? arguments[1] : undefined;
    var value = arguments.length > 2 ? arguments[2] : undefined;
    if (keys.length === 1) {
      obj[keys[0]] = value;
    } else {
      var _keys = _toArray(keys),
        firstKey = _keys[0],
        restKeys = _arrayLikeToArray(_keys).slice(1);
      updateNestedField(obj[firstKey], restKeys, value);
    }
  };
  var handleFormChange = function handleFormChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value,
      checked = _e$target.checked;
    var newValue = e.target.type === "checkbox" ? checked : value;
    return setFormFields(function (prevState) {
      var newState = _objectSpread({}, prevState);
      var keys = name.split(".");
      updateNestedField(newState, keys, newValue);
      updateNestedField(keyJson, keys, newValue);
      return newState;
    });
  };
  function checkAndConvert(value) {
    return typeof value === "string" || value instanceof String ? value : JSON.stringify(value);
  }
  var checkAndConvertInput = function checkAndConvertInput(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    tryConvert(name, value);
    handleFormChange(event);
  };
  function tryConvert(name, value) {
    try {
      JSON.parse(value);
      setErrorText(_objectSpread(_objectSpread({}, errorText), {}, _defineProperty({}, name, "")));
    } catch (error) {
      setErrorText(_objectSpread(_objectSpread({}, errorText), {}, _defineProperty({}, name, "Invalid JSON format, " + error)));
      return value;
    }
  }
  return /*#__PURE__*/_jsx("form", {
    onSubmit: handleFormSubmit,
    children: /*#__PURE__*/_jsxs(Grid, {
      container: true,
      spacing: 3,
      style: {
        width: "inherit",
        margin: "inherit"
      },
      children: [/*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        md: 6,
        children: /*#__PURE__*/_jsx(TextField, {
          name: "bolt",
          label: "BOLT endpoint",
          helperText: "e.g., bolt://...:24786",
          value: formFields.bolt,
          onChange: handleFormChange,
          fullWidth: true
        })
      }), /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        md: 6,
        children: /*#__PURE__*/_jsxs(FormControl, {
          fullWidth: true,
          children: [/*#__PURE__*/_jsx(InputLabel, {
            id: "select-label",
            children: "Neo4j driver version"
          }), /*#__PURE__*/_jsx(Select, {
            native: true,
            label: "Neo4j driver version",
            labelId: "select-label",
            name: "driverVersion",
            value: formFields.driverVersion,
            onChange: handleFormChange,
            children: ["4.0", "4.1", "4.4"].map(function (option, index) {
              return /*#__PURE__*/_jsx("option", {
                value: option,
                children: option.toString()
              }, index);
            })
          }), /*#__PURE__*/_jsx(FormHelperText, {
            children: "'4.0', '4.1', or '4.4' (default)"
          })]
        })
      }), /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/_jsxs(Paper, {
          elevation: 3,
          style: {
            padding: 16
          },
          children: [/*#__PURE__*/_jsx(Grid, {
            item: true,
            xs: 12,
            children: /*#__PURE__*/_jsx(Typography, {
              variant: "h6",
              component: "h6",
              children: "Authentication"
            })
          }), /*#__PURE__*/_jsxs(Grid, {
            container: true,
            spacing: 2,
            children: [/*#__PURE__*/_jsx(Grid, {
              item: true,
              xs: 12,
              md: 6,
              children: /*#__PURE__*/_jsx(TextField, {
                name: "auth.scheme",
                label: "Auth scheme",
                value: formFields.auth.scheme,
                onChange: handleFormChange,
                fullWidth: true
              })
            }), /*#__PURE__*/_jsx(Grid, {
              item: true,
              xs: 12,
              md: 6,
              children: /*#__PURE__*/_jsx(TextField, {
                name: "auth.principal",
                label: "Username or principal"
                // helperText="Replaces neo4j.user"
                ,

                value: formFields.auth.principal,
                onChange: handleFormChange,
                fullWidth: true
              })
            }), /*#__PURE__*/_jsx(Grid, {
              item: true,
              xs: 12,
              md: 6,
              children: /*#__PURE__*/_jsx(TextField, {
                name: "auth.credentials",
                label: "Password or credential",
                type: showPassword ? "text" : "password",
                value: formFields.auth.credentials,
                onChange: handleFormChange,
                fullWidth: true,
                InputProps: {
                  endAdornment: /*#__PURE__*/_jsx(InputAdornment, {
                    position: "end",
                    children: /*#__PURE__*/_jsx(IconButton, {
                      onClick: handleTogglePasswordVisibility,
                      children: showPassword ? /*#__PURE__*/_jsx(Visibility, {}) : /*#__PURE__*/_jsx(VisibilityOff, {})
                    })
                  })
                }
              })
            }), /*#__PURE__*/_jsx(Grid, {
              item: true,
              xs: 12,
              md: 6,
              children: /*#__PURE__*/_jsx(TextField, {
                name: "auth.realm",
                label: "Auth realm",
                value: formFields.auth.realm,
                onChange: handleFormChange,
                fullWidth: true
              })
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        md: 12,
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "h6",
          component: "h6",
          children: "Optional"
        })
      }), type === "Neptune" ? /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/_jsx(Paper, {
          elevation: 3,
          style: {
            padding: 16
          },
          children: /*#__PURE__*/_jsxs(Grid, {
            item: true,
            xs: 12,
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "h6",
              component: "h6",
              children: "Neptune"
            }), /*#__PURE__*/_jsxs(Grid, {
              container: true,
              spacing: 2,
              children: [/*#__PURE__*/_jsx(Grid, {
                item: true,
                xs: 12,
                md: 6,
                children: /*#__PURE__*/_jsx(FormControlLabel, {
                  control: /*#__PURE__*/_jsx(Checkbox, {
                    checked: formFields.neptune.signedHeader,
                    onChange: handleFormChange,
                    name: "neptune.signedHeader"
                  }),
                  label: "Generate Neptune-specific signed header instead of raw credentials string"
                })
              }), formFields.neptune.signedHeader ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "neptune.protocol",
                    label: "Neptune signed header protocol",
                    value: formFields.neptune.protocol,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "neptune.hostname",
                    label: "Neptune signed header hostname",
                    value: formFields.neptune.hostname,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "neptune.port",
                    label: "Neptune signed header port",
                    value: formFields.neptune.port,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "neptune.path",
                    label: "Neptune signed header path: ",
                    helperText: "Set to \"/opencypher\" if engine >= 1.2.0.0",
                    value: formFields.neptune.path,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "neptune.region",
                    label: "Neptune signed header region",
                    placeholder: "us-east-1",
                    value: formFields.neptune.region,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "neptune.service",
                    label: "Neptune signed header service",
                    placeholder: "neptune-db",
                    value: formFields.neptune.service,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                })]
              }) : null]
            })]
          })
        })
      }) : null, /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        md: 6,
        children: /*#__PURE__*/_jsxs(FormControl, {
          fullWidth: true,
          children: [/*#__PURE__*/_jsx(InputLabel, {
            id: "select-label",
            children: "Neo4j driver logging level"
          }), /*#__PURE__*/_jsxs(Select, {
            native: true,
            label: "Neo4j driver logging level",
            labelId: "select-label",
            name: "logging.level",
            value: formFields.logging.level,
            onChange: handleFormChange,
            disabled: !isSuperUserOrStaff,
            children: [/*#__PURE__*/_jsx("option", {
              "aria-label": "None",
              value: ""
            }), ["error", "warn", "info", "debug"].map(function (option, index) {
              return /*#__PURE__*/_jsx("option", {
                value: option,
                children: option.toString()
              }, index);
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        md: 6,
        children: /*#__PURE__*/_jsx(FormControlLabel, {
          disabled: !isSuperUserOrStaff,
          control: /*#__PURE__*/_jsx(Checkbox, {
            checked: formFields.persistConnection,
            onChange: handleFormChange,
            name: "persistConnection"
          }),
          label: "Whether to maintain a connection or start a new driver session per query"
        })
      }), /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        md: 6,
        children: /*#__PURE__*/_jsx(TextField, {
          name: "searchMaxTime",
          label: "Search maximum time",
          helperText: "Maximum time (in milliseconds) allowed for executing a Neo4j search query.",
          value: formFields.searchMaxTime,
          onChange: handleFormChange,
          fullWidth: true
        })
      }), /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        md: 6,
        children: /*#__PURE__*/_jsx(TextField, {
          name: "metadata",
          label: "Transaction metadata",
          placeholder: "{'key':'value}",
          value: formFields.metadata,
          helperText: errorText["metadata"],
          fullWidth: true,
          error: !!errorText["metadata"],
          rows: 4,
          variant: "outlined",
          onChange: checkAndConvertInput
        })
      }), isSuperUserOrStaff && /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/_jsx(Paper, {
          elevation: 3,
          style: {
            padding: 16
          },
          children: /*#__PURE__*/_jsxs(Grid, {
            item: true,
            xs: 12,
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "h6",
              component: "h6",
              children: "Schema"
            }), /*#__PURE__*/_jsxs(Grid, {
              container: true,
              spacing: 2,
              children: [/*#__PURE__*/_jsx(Grid, {
                item: true,
                xs: 12,
                sm: 6,
                children: /*#__PURE__*/_jsx(ArrayForm, {
                  label: "Node properties",
                  helperText: "Default node properties to time filter on when available (use as few as possible)",
                  name: "schema.defaultTimeIndex.nodeProperties",
                  rowName: "Node properties",
                  value: formFields.schema.defaultTimeIndex.nodeProperties,
                  onChange: handleFormChange
                })
              }), /*#__PURE__*/_jsx(Grid, {
                item: true,
                xs: 12,
                sm: 6,
                children: /*#__PURE__*/_jsx(ArrayForm, {
                  label: "Relationship properties",
                  helperText: "Default relationship properties to time filter on when available (use as few as possible)",
                  name: "schema.defaultTimeIndex.relationshipProperties",
                  rowName: "Relationship properties",
                  value: formFields.schema.defaultTimeIndex.relationshipProperties,
                  onChange: handleFormChange
                })
              }), /*#__PURE__*/_jsx(Grid, {
                item: true,
                xs: 12,
                sm: 6,
                children: /*#__PURE__*/_jsxs(TextField, {
                  label: "Infer schema",
                  helperText: "Infer schema on system start (db.schema)",
                  fullWidth: true,
                  name: "schema.inferSchema",
                  value: formFields.schema.inferSchema,
                  onChange: handleFormChange,
                  select: true,
                  SelectProps: {
                    native: true
                  },
                  children: [/*#__PURE__*/_jsx("option", {
                    value: "true",
                    children: "True"
                  }), /*#__PURE__*/_jsx("option", {
                    value: "false",
                    children: "False"
                  })]
                })
              }), /*#__PURE__*/_jsx(Grid, {
                item: true,
                xs: 12,
                sm: 6,
                children: /*#__PURE__*/_jsx(TextField, {
                  label: "Infer timeout",
                  helperText: "Seconds after which to abandon each schema inference query",
                  fullWidth: true,
                  name: "schema.inferTimeout",
                  value: formFields.schema.inferTimeout,
                  onChange: handleFormChange
                })
              }), /*#__PURE__*/_jsx(Grid, {
                item: true,
                xs: 12,
                sm: 6,
                children: /*#__PURE__*/_jsx(TextField, {
                  label: "Label properties",
                  helperText: errorText["schema.labelProperties"],
                  fullWidth: true,
                  rows: 4,
                  type: "text",
                  variant: "outlined",
                  error: !!errorText["schema.labelProperties"],
                  name: "schema.labelProperties",
                  placeholder: "{'key':'value}",
                  value: checkAndConvert(formFields.schema.labelProperties),
                  onChange: checkAndConvertInput
                })
              }), /*#__PURE__*/_jsx(Grid, {
                item: true,
                xs: 12,
                sm: 6,
                children: /*#__PURE__*/_jsx(TextField, {
                  label: "Relationship properties",
                  helperText: errorText["schema.relationshipProperties"],
                  fullWidth: true,
                  rows: 4,
                  error: !!errorText["schema.relationshipProperties"],
                  variant: "outlined",
                  type: "text",
                  name: "schema.relationshipProperties",
                  placeholder: "{'key':'value}",
                  value: checkAndConvert(formFields.schema.relationshipProperties),
                  onChange: checkAndConvertInput
                })
              }), /*#__PURE__*/_jsx(Grid, {
                item: true,
                xs: 12,
                sm: 6,
                children: /*#__PURE__*/_jsx(ArrayForm, {
                  label: "Text indexes",
                  helperText: "Define text indexes to use for text searches.",
                  placeholder: "{ \n \tdescription: str    \n \tindexName: str\n \ttokenNames: [ str ]\n \tproperties: [ str ]\n \ttype: \"node_fulltext\" | \"relationship_fulltext\"\n}",
                  propRows: 7,
                  fullWidth: true,
                  name: "schema.textIndexes",
                  rowName: "Text indexes",
                  value: formFields.schema.textIndexes,
                  onChange: handleFormChange
                })
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/_jsx(Root, {
          children: /*#__PURE__*/_jsxs(Accordion, {
            style: {
              padding: 16
            },
            children: [/*#__PURE__*/_jsx(AccordionSummary, {
              expandIcon: /*#__PURE__*/_jsx(ExpandMore, {}),
              children: /*#__PURE__*/_jsx(Typography, {
                variant: "h6",
                component: "h6",
                children: "Advanced configuration"
              })
            }), /*#__PURE__*/_jsx(AccordionDetails, {
              children: /*#__PURE__*/_jsxs(Grid, {
                container: true,
                spacing: 2,
                children: [/*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsxs(FormControl, {
                    fullWidth: true,
                    children: [/*#__PURE__*/_jsx(InputLabel, {
                      id: "select-label",
                      children: "Neo4j driver config encrypted"
                    }), /*#__PURE__*/_jsxs(Select, {
                      native: true,
                      labelId: "select-label",
                      label: "Neo4j driver config encrypted",
                      name: "driverConfig.encrypted",
                      value: formFields.driverConfig.trustedCertificates,
                      onChange: handleFormChange,
                      children: [/*#__PURE__*/_jsx("option", {
                        "aria-label": "None",
                        value: ""
                      }), [true, false, "ENCRYPTION_ON", "ENCRYPTION_OFF"].map(function (option, index) {
                        return /*#__PURE__*/_jsx("option", {
                          value: option,
                          children: option.toString()
                        }, index);
                      })]
                    })]
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsxs(FormControl, {
                    fullWidth: true,
                    children: [/*#__PURE__*/_jsx(InputLabel, {
                      id: "select-label",
                      children: "Neo4j driver config trust"
                    }), /*#__PURE__*/_jsxs(Select, {
                      native: true,
                      labelId: "select-label",
                      label: "Neo4j driver config trust",
                      name: "driverConfig.trust",
                      value: formFields.driverConfig.knownHosts,
                      onChange: handleFormChange,
                      children: [/*#__PURE__*/_jsx("option", {
                        "aria-label": "None",
                        value: ""
                      }), ["TRUST_ALL_CERTIFICATES", "TRUST_CUSTOM_CA_SIGNED_CERTIFICATES", "TRUST_SYSTEM_CA_SIGNED_CERTIFICATES"].map(function (option, index) {
                        return /*#__PURE__*/_jsx("option", {
                          value: option,
                          children: option.toString()
                        }, index);
                      })]
                    })]
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(ArrayForm, {
                    name: "driverConfig.trustedCertificates",
                    label: "Neo4j driver config trusted certificates (array)",
                    value: formFields.driverConfig.trustedCertificates,
                    onChange: handleFormChange,
                    rowName: "Trusted certificates"
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "driverConfig.knownHosts",
                    label: "Neo4j driver config known hosts",
                    value: formFields.driverConfig.knownHosts,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "driverConfig.fetchSize",
                    label: "Neo4j driver config fetch size",
                    value: formFields.driverConfig.fetchSize,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "driverConfig.maxConnectionPoolSize",
                    label: "Neo4j driver config max connection pool size",
                    value: formFields.driverConfig.maxConnectionPoolSize,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "driverConfig.maxTransactionRetryTime",
                    label: "Neo4j driver config max transaction retry time",
                    value: formFields.driverConfig.maxTransactionRetryTime,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "driverConfig.maxConnectionLifetime",
                    label: "Neo4j driver config max connection lifetime",
                    value: formFields.driverConfig.maxConnectionLifetime,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "driverConfig.connectionAcquisitionTimeout",
                    helperText: "Neo4j driver config connection acquisition timeout",
                    label: "Connection acquisition timeout",
                    value: formFields.driverConfig.connectionAcquisitionTimeout,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "driverConfig.connectionTimeout",
                    label: "Neo4j driver config connection timeout",
                    value: formFields.driverConfig.connectionTimeout,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(FormControlLabel, {
                    control: /*#__PURE__*/_jsx(Checkbox, {
                      checked: formFields.driverConfig.disableLosslessIntegers,
                      onChange: handleFormChange,
                      name: "driverConfig.disableLosslessIntegers"
                    }),
                    label: "Neo4j driver config disable lossless integers"
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(FormControlLabel, {
                    control: /*#__PURE__*/_jsx(Checkbox, {
                      checked: formFields.driverConfig.useBigInt,
                      onChange: handleFormChange,
                      name: "driverConfig.useBigInt"
                    }),
                    label: "Neo4j driver config use big int"
                  })
                }), /*#__PURE__*/_jsx(Grid, {
                  item: true,
                  xs: 12,
                  md: 6,
                  children: /*#__PURE__*/_jsx(TextField, {
                    name: "driverConfig.userAgent",
                    label: "Neo4j driver config user agent",
                    value: formFields.driverConfig.userAgent,
                    onChange: handleFormChange,
                    fullWidth: true
                  })
                })]
              })
            })]
          })
        })
      })]
    })
  });
};
export default BoltForm;